import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { authClient } from "../lib/auth.ts";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { data: session, isPending } = authClient.useSession();

  if (isPending) {
    return (
      <div className="flex h-full items-center justify-center text-[var(--color-muted)]">
        Laddar session…
      </div>
    );
  }
  if (!session?.user) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
